import { render, staticRenderFns } from "./ProVersionPartnershipSidebar.vue?vue&type=template&id=3ba4d244&"
import script from "./ProVersionPartnershipSidebar.vue?vue&type=script&lang=js&"
export * from "./ProVersionPartnershipSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports